import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { AsyncPipe } from '@angular/common';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { Changelog } from '../../../../core/models/changelog.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { ChangelogService } from '../../../../core/services/changelog/changelog-service';
import { Title } from '@angular/platform-browser';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { ChangelogForm } from '../changelog-form/changelog-form';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-changelog-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    OnlysuperuserDirective,
    PermisionDirective,
    MatDividerModule,
    Search,
  ],
  templateUrl: './changelogs-list.html',
  styleUrl: './changelogs-list.scss',
})
export class ChangelogList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  changelog: Changelog[] = [];
  asyncChangelog!: Observable<Changelog[]>;
  buscarchangelog: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = [ 'acciones','id', 'version', 'featureDesc', 'bugFixesDesc', 'releaseDate'];


  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private changelogService: ChangelogService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Versiones');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchChangelog(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchChangelog(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncChangelog = this.changelogService.getChangelogs(params).pipe(
      tap((data) => {
        this.changelog = data.results;
        this.changelogService.setChangelog(data.results[0]);
        this.changelogService.setChangelogs(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createChangelog() {
    this.changelogService.removeChangelogSelected();
    const dialogRef = this.dialog.open(ChangelogForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchChangelog(this.page);
    });
  }

  updateChangelog(changelog: Changelog) {
    this.changelogService.setChangelog(changelog);
    const dialogRef = this.dialog.open(ChangelogForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchChangelog(this.page);
    });
  }

  eliminate(id: number): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el changelog?`);
    if (!confirmed) return;
    this.changelogService.deleteChangelog(id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchChangelog(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
